import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/betHistory.css';
import settledBetsStyle from '../css/settledBets.css';
// components
import Accordion from '../components/accordion';
import {
    AMERICAN_FOOTBALL_MODULE,
    BASEBALL_MODULE,
    BASKETBALL_MODULE,
    CRICKET_MODULE,
    FIRST_DOWN_MODULE,
    FOOTBALL_MODULE,
    MATCHDAY_MODULE,
    RACING_MODULE,
    SETTLED_IN_HISTORY,
    TENNIS_MODULE,
    VOIDED,
} from "../../../constants/identifiers";
import LockedBetRacing from "../modules/racing/components/lockedBetRacing";
import LockedBetFootball from "../modules/football/components/lockedBetFootball";
import LockedBetFirstDown from "../modules/firstDown/components/lockedBetFirstDown";
//helpers
import {getModuleFromEventType} from "../../../helpers/moduleHelpers";
import {getText} from "../../../helpers/localization";
import {closeBetHistory, toggleFilterWinsBetHistory} from "../actions/betHistoryActions";
import LockedBetBasketball from "../modules/basketball/components/lockedBetBasketball";
import LockedBetAmericanFootball from "../modules/americanFootball/components/lockedBetAmericanFootball";
import LockedBetMatchday from "../modules/matchday/components/lockedBetMatchday";
import {getGameCategoryNameByChannel} from '../helpers/gameHelpers';
import LockedBetCricket from '../modules/cricket/components/lockedBetCricket';
import LockedBetTennis from '../modules/tennis/components/lockedBetTennis';
import LockedBetBaseBall from '../modules/baseball/components/lockedBetBaseball';


const mapStateToProps = (state, ownProps) => {
    return {
        betHistory: state.vpp.betHistory,
        filterWinsBetHistory: state.vpp.filterWinsBetHistory,
        systemLanguage: state.vpp.systemLanguage
    };
};

class BetHistory extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            betHistory: storeData.vpp.betHistory,
            filterWinsBetHistory: storeData.vpp.filterWinsBetHistory,
            systemLanguage: storeData.vpp.systemLanguage
        };

    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                betHistory: storeData.vpp.betHistory,
                filterWinsBetHistory: storeData.vpp.filterWinsBetHistory,
                systemLanguage: storeData.vpp.systemLanguage
            });
        }
    }

    render() {
        let historicalBets;
        let isEmpty = true;
        let gameCategories;
        let getGameCategory = (betSelection, store) => getGameCategoryNameByChannel(this.props.store, betSelection.Bets[0].Channel);
        if (this.props.store.getState().vpp.games !== undefined && this.state.betHistory.length > 0) {
            let betHistoryBets = this.state.betHistory;
            if (this.state.filterWinsBetHistory === true) {
                betHistoryBets = betHistoryBets.filter(sb => Number(sb.Bets[0].Prize) > 0 && sb.Bets[0].State !== VOIDED);
            }
            betHistoryBets.sort((a, b) => b.Bets[0].EventTime - a.Bets[0].EventTime);
            gameCategories = [...new Set(betHistoryBets.map(betSelection => getGameCategoryNameByChannel(this.props.store, betSelection.Bets[0].Channel)))];
            historicalBets = gameCategories.map((gameCategory, gameIndex) => {

                let historyBetOfGivenCategory = betHistoryBets.filter((betSelection) => gameCategory === getGameCategory(betSelection, this.props.store));
                if (historyBetOfGivenCategory !== undefined && historyBetOfGivenCategory.length !== 0 && getModuleFromEventType(historyBetOfGivenCategory[0].Bets[0].EventType) === MATCHDAY_MODULE) {
                    historyBetOfGivenCategory.sort(function (a, b) {
                        if (a.Bets.length > b.Bets.length) return 1;
                        if (a.Bets.length < b.Bets.length) return -1;
                        if (a.Bets[0].LastUpdatedDate > b.Bets[0].LastUpdatedDate) return -1;
                        if (a.Bets[0].LastUpdatedDate < b.Bets[0].LastUpdatedDate) return 1;
                    });
                }

                return historyBetOfGivenCategory.map((betSelection, betSelectionIndex) => {
                    isEmpty = false;
                    let historicalBetCard = null;
                    if (betSelection.Bets[0].EventType !== undefined) {
                        switch (getModuleFromEventType(betSelection.Bets[0].EventType)) {
                            case RACING_MODULE:
                                historicalBetCard = (
                                    <LockedBetRacing key={gameIndex + betSelectionIndex}
                                                     index={gameIndex + '_' + betSelectionIndex}
                                                     store={this.props.store} betSelection={betSelection}
                                                     isSettledBet={true} betsType={SETTLED_IN_HISTORY}/>);
                                break;
                            case FOOTBALL_MODULE:
                                historicalBetCard = (
                                    <LockedBetFootball key={gameIndex + betSelectionIndex}
                                                       index={gameIndex + betSelectionIndex}
                                                       store={this.props.store} betSelection={betSelection}
                                                       isSettledBet={true} betsType={SETTLED_IN_HISTORY}/>);
                                break;
                            case BASKETBALL_MODULE:
                                historicalBetCard = (
                                    <LockedBetBasketball key={gameIndex + betSelectionIndex}
                                                         index={gameIndex + betSelectionIndex}
                                                         store={this.props.store} betSelection={betSelection}
                                                         isSettledBet={true} betsType={SETTLED_IN_HISTORY}/>);
                                break;
                            case AMERICAN_FOOTBALL_MODULE:
                                historicalBetCard = (
                                    <LockedBetAmericanFootball key={gameIndex + betSelectionIndex}
                                                               index={gameIndex + betSelectionIndex}
                                                               store={this.props.store} betSelection={betSelection}
                                                               isSettledBet={true} betsType={SETTLED_IN_HISTORY}/>);
                                break;
                            case FIRST_DOWN_MODULE:
                                historicalBetCard = (
                                    <LockedBetFirstDown key={gameIndex + betSelectionIndex}
                                                        index={gameIndex + betSelectionIndex}
                                                        store={this.props.store} betSelection={betSelection}
                                                        isSettledBet={true} betsType={SETTLED_IN_HISTORY}/>);
                                break;
                            case MATCHDAY_MODULE:
                                historicalBetCard = (
                                    <LockedBetMatchday key={gameIndex + betSelectionIndex}
                                                       index={gameIndex + betSelectionIndex}
                                                       store={this.props.store} isSettledBet={true}
                                                       betSelection={betSelection} betsType={SETTLED_IN_HISTORY}/>);
                                break;
                            case CRICKET_MODULE:
                                historicalBetCard = (
                                    <LockedBetCricket key={gameIndex + betSelectionIndex}
                                                          index={gameIndex + betSelectionIndex}
                                                          store={this.props.store} isSettledBet={true}
                                                          betSelection={betSelection} betsType={SETTLED_IN_HISTORY}/>)
                                break;
                            case TENNIS_MODULE:
                                historicalBetCard = (
                                    <LockedBetTennis key={gameIndex + betSelectionIndex}
                                                          index={gameIndex + betSelectionIndex}
                                                          store={this.props.store} isSettledBet={true}
                                                          betSelection={betSelection} betsType={SETTLED_IN_HISTORY}/>);
                                break;
                            case BASEBALL_MODULE:
                                historicalBetCard=(
                                    <LockedBetBaseBall key={gameIndex + betSelectionIndex}
                                    index={gameIndex + betSelectionIndex}
                                    store={this.props.store} isSettledBet={true}
                                    betSelection={betSelection} betsType={SETTLED_IN_HISTORY}/>
                                )
                                break;
                            default:
                                historicalBetCard = (<div key={gameIndex + betSelectionIndex}/>);
                                break;
                        }
                    }

                    return historicalBetCard;
                });
            });
        }

        let historicalBetsUI;
        if (isEmpty) {
            historicalBetsUI = (<div className={style.noBetsText}>{getText('NO_BETS', this.props.store)}</div>);
        } else {
            historicalBetsUI = historicalBets.map((historicalBetsPerCategory, index) => {
                if (historicalBetsPerCategory.length > 0) {
                    let content = <div>{historicalBetsPerCategory}</div>;
                    return <Accordion key={index} id={'game_accordion_' + index}
                                      store={this.props.store}
                                      content={content}
                                      isExpanded={true}
                                      label={getText('betSlip_' + gameCategories[index], this.props.store)}/>;
                }
                return null;
            });
        }

        let filterWinsButton = null;
        if (!isEmpty || true) {

            let isCheckStyle = this.state.filterWinsBetHistory ? settledBetsStyle.selected : '';

            filterWinsButton = (
                <div
                    id={'filter_wins_history'}
                    className={`${settledBetsStyle.filterWins} ${this.state.filterWinsBetHistory ? settledBetsStyle.selected : ''}`}
                    onClick={() => this.props.store.dispatch(toggleFilterWinsBetHistory())}>
                    <div className={settledBetsStyle.filterWinsLabel}>{getText('FILTER_WINS', this.props.store)}</div>
                    <div className={`${settledBetsStyle.checkBox} ${isCheckStyle}`}/>
                </div>
            );
        }

        return (<div className={style.modalContentWrapper}>
                <div className={style.modalContentHeader}>
                    <div
                        id={'bet_history_tab'}
                        className={`${style.headerItem}`}>
                        <div className={style.headerItemText}>{getText('BET_HISTORY', this.props.store)}</div>
                    </div>
                    <div
                        id={'close_bet_history_tab'}
                        className={style.closeButtonContainer}
                        onClick={() => this.props.store.dispatch(closeBetHistory())}>
                        <div className={style.closeButtonWrap}>
                            <div className={style.closeButton} alt={'close'}></div>
                        </div>
                    </div>
                </div>
                <div className={style.modalContentBody}>
                    {historicalBetsUI}
                </div>
                <div className={settledBetsStyle.bottomContainer}>
                    <div className={settledBetsStyle.buttonsContainer}>
                        {filterWinsButton}
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(BetHistory);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/containers/betHistory.js